/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { queryOptions, useQuery, useSuspenseQuery } from '@tanstack/react-query'
import type {
	UseQueryOptions,
	UseQueryResult,
	UseSuspenseQueryOptions,
	UseSuspenseQueryResult,
} from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { brandingsShow } from '../../axios/brandingsShow'
import type { BrandingsShowError, BrandingsShowPathParams, BrandingsShowResponse } from '../../types/BrandingsShow'

export const brandingsShowQueryKey = (branding: BrandingsShowPathParams['branding']) =>
	[{ url: '/brandings/:branding', params: { branding } }] as const

export type BrandingsShowQueryKey = ReturnType<typeof brandingsShowQueryKey>

/** @see backend/nexus/modules/Branding/Http/Controllers/BrandingController.php BrandingController::show */
export function brandingsShowQueryOptions(branding: BrandingsShowPathParams['branding'], config?: AxiosRequestConfig) {
	return queryOptions<
		BrandingsShowResponse,
		AxiosError<BrandingsShowError>,
		BrandingsShowResponse,
		BrandingsShowQueryKey
	>({
		queryKey: brandingsShowQueryKey(branding),
		queryFn: ({ signal }) => brandingsShow(branding, { signal, ...config }).then(res => res.data),
		enabled: !!branding,
	})
}

/** @see backend/nexus/modules/Branding/Http/Controllers/BrandingController.php BrandingController::show */
export function useBrandingsShow<TSelectData = BrandingsShowResponse>(
	branding: BrandingsShowPathParams['branding'],
	options?:
		& Partial<
			Omit<
				UseQueryOptions<
					BrandingsShowResponse,
					AxiosError<BrandingsShowError>,
					TSelectData,
					BrandingsShowQueryKey
				>,
				'queryKey' | 'queryFn'
			>
		>
		& { queryKey?: readonly unknown[] },
): UseQueryResult<TSelectData, AxiosError<BrandingsShowError>> {
	const { queryKey: customQueryKey, ...opts } = options ?? {}
	return useQuery({
		...brandingsShowQueryOptions(branding),
		...opts as any,
		...(customQueryKey ? { queryKey: customQueryKey as any } : {}),
	})
}

/** @see backend/nexus/modules/Branding/Http/Controllers/BrandingController.php BrandingController::show */
export function useBrandingsShowSuspense<TSelectData = BrandingsShowResponse>(
	branding: BrandingsShowPathParams['branding'],
	options?:
		& Partial<
			Omit<
				UseSuspenseQueryOptions<
					BrandingsShowResponse,
					AxiosError<BrandingsShowError>,
					TSelectData,
					BrandingsShowQueryKey
				>,
				'queryKey' | 'queryFn'
			>
		>
		& { queryKey?: readonly unknown[] },
): UseSuspenseQueryResult<TSelectData, AxiosError<BrandingsShowError>> {
	const { queryKey: customQueryKey, ...opts } = options ?? {}
	return useSuspenseQuery({
		...brandingsShowQueryOptions(branding),
		...opts as any,
		...(customQueryKey ? { queryKey: customQueryKey as any } : {}),
	})
}
